import cloudflare from "@/assets/partners/cloudflare.png";
import cloudlinux from "@/assets/partners/cloudlinux.png";
import cpanel from "@/assets/partners/cpanel.png";
import imunify360 from "@/assets/partners/imunify360.png";
import litespeed from "@/assets/partners/litespeed.png";
import softaculous from "@/assets/partners/softaculous.png";
import wordpress from "@/assets/partners/wordpress.png";

const partners = [
  { name: "Cloudflare", logo: cloudflare, alt: "Cloudflare CDN and DDoS protection for BDIX hosting" },
  { name: "CloudLinux", logo: cloudlinux, alt: "CloudLinux OS for secure Bangladesh web hosting" },
  { name: "cPanel", logo: cpanel, alt: "cPanel control panel for easy website management" },
  { name: "LiteSpeed", logo: litespeed, alt: "LiteSpeed web server for high-performance BDIX hosting" },
  { name: "Imunify360", logo: imunify360, alt: "Imunify360 security for Bangladesh hosting servers" },
  { name: "Softaculous", logo: softaculous, alt: "Softaculous one-click installer for WordPress and 400+ apps" },
  { name: "WordPress", logo: wordpress, alt: "WordPress optimized hosting in Bangladesh" },
];

const PartnersSection = () => {
  // Triplicate the partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <section className="py-16 bg-background border-y border-border overflow-hidden w-screen relative left-1/2 right-1/2 -mx-[50vw]" aria-label="Technology partners">
      <div className="text-center mb-10 px-4">
        <span className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
          Trusted Technology Partners for BDIX Hosting in Bangladesh
        </span>
      </div>

      <div className="relative">
        {/* Gradient overlays for smooth fade effect - positioned at viewport edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" aria-hidden="true" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" aria-hidden="true" />

        {/* Scrolling container */}
        <div className="flex animate-scroll">
          {duplicatedPartners.map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              className="flex-shrink-0 mx-12 flex items-center justify-center"
            >
              <img 
                src={partner.logo} 
                alt={partner.alt}
                className="h-10 md:h-12 w-auto object-contain"
                width={160}
                height={48}
                style={{ maxWidth: '160px' }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;